module.exports = __webpack_public_path__ + "assets/images/project/people/man.svg?v=3f58aba0";